<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<el-row>
				<el-col :span="6" style="padding:20px 10px;font-size: 20px;font-weight: bold;">
					猫咪终生服务 — 精致套餐
				</el-col>
				<el-col :span="2" :offset="16" style="padding:10px 20px;">
					<el-button @click="back" size="mini">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div style="margin:0 10px;">
			<div class="box" :class="indexs.indexOf(index)>-1?'active':''" v-for="(item,index) in 5" :key="index">
				<div class="boxTit" @click="switchIndexs(index)">
					<div style="display: inline-block;width:0;border:5px solid transparent;border-top-color: #000000;margin:0 5px -2px 5px;"></div>
					<span>宠物健康</span>
				</div>
				<div class="boxTable">
					<div class="tableLine">
						<span class="tableItem">项目</span>
						<span class="tableItem">剩余次数</span>
						<span class="tableItem">周期</span>
						<span class="tableItem">刷新时间</span>
						<span class="tableItem">操作人</span>
						<span class="tableItem">操作</span>
					</div>
					<div class="tableBody">
						<div class="tableLine">
							<span class="tableItem">宠物防疫本</span>
							<span class="tableItem">0/1</span>
							<span class="tableItem">每年一次</span>
							<span class="tableItem">刷新时间</span>
							<span class="tableItem">操作人</span>
							<span class="tableItem">
								<span style="cursor: pointer;" @click="seesee(1)">核销</span>
								<span style="cursor: pointer;" @click="seesee(1)">查看</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				indexs:[],
				tableData:[],
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
		},
		mounted(){
			this.getDetail();
		},
		methods: {
			back(){
				this.$store.commit('huiyuanquanyi/set_type','list')
			},
			switchIndexs(num){
				let index = -1;
				for(let i=0;i<this.indexs.length;i++){
					if(this.indexs[i]===num){
						index=i
					}
				}
				if(index===-1){
					this.indexs.push(num)
				}else{
					this.indexs.splice(index,1)
				}
			},
			seesee(num){
				console.log(num)
				this.$store.commit('huiyuanquanyi/set_type','seesee')
			},
			// 获取寄养列表
			getDetail() {
				let loading=this.$loading();
				let params = {
				}
				console.log(params)
				this.$http.post('/api/Case/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:0 0 20px;box-sizing: border-box;overflow: auto;
	.titleLine{
		width:100%;
		background-color: #fff;
		padding:8px 8px 8px;
		box-sizing: border-box;
		margin-bottom: 4px;
	}
	.box{
		margin-bottom:16px;
		&.active{
			.boxTable{
				height: 0;
				padding-bottom:0;
			}
		}
		.boxTit{
			background-color: #E2E2E2;line-height: 40px;color:#2A2A2A;font-size: 14px;padding:0 20px;cursor: pointer;
			-moz-user-select:none; /*火狐*/
			-webkit-user-select:none; /*webkit浏览器*/
			-ms-user-select:none; /*IE10*/
			user-select:none;
		}
		.boxTable{
			background-color: #f4f4f4;padding:0 30px 20px 30px;box-sizing: border-box;overflow: hidden;
			.tableLine{
				display: flex;justify-content: space-between;border-bottom:1px solid #AEAEAE;
				.tableItem{
					font-size: 14px;line-height: 46px;padding:0 20px;
				}
			}
		}
	}
}
</style>
